import { useEffect } from "react";
import { useTogglePopup } from "./useTogglePopup";
import { GET_POPUP_TYPES } from "../constants/popupConfig";
import { useGetJWTSportsBookData } from "../queries/useGetJWTSportsBook";
import { sendToast } from "../components/molecules/Toast";

export const usePostMessageGR8 = () => {
  const { openPopup } = useTogglePopup();
  const { refetch } = useGetJWTSportsBookData();

  useEffect(() => {
    const messageHandler = (data) => {
      if (data.origin !== "https://sport-iframe.pjdoi.xyz") {
        return;
      }
      const { data: messageData } = data;

      try {
        if (!messageData.type) {
          // eslint-disable-next-line no-console
          console.warn(
            "Message received without eventName, ignoring.",
            messageData,
          );
          return;
        }
        switch (messageData.type) {
          case "login.click":
            openPopup(GET_POPUP_TYPES.popup.signUp);

            break;
          case "user.balance":
            // eslint-disable-next-line no-console
            console.log("user.balance!");
            break;

          case "auth.fail":
            // eslint-disable-next-line no-console
            console.log("auth.fail", messageData);
            refetch().catch(() => {
              sendToast({
                title: "Error auth on GR8",
                variant: "red",
              });
            });

            break;

          default:
            // eslint-disable-next-line no-console
            console.log("Error:", messageData);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(
          "Error parsing JSON from postMessage:",
          error,
          "Received data:",
          messageData,
        );
      }
    };

    window.addEventListener("message", messageHandler);

    return () => {
      window.removeEventListener("message", messageHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
